<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        color="var(--theme-color-one)"
        outlined>
        ดาวน์โหลดข้อมูล
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-if="daterange != 'day'">
        <v-list-item-title>ดาวน์โหลดปฏิทิน</v-list-item-title>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>ดาวน์โหลดข้อมูล (.xlxs)</v-list-item-title>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>ดาวน์โหลดข้อมูล (.pdf)</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

export default {
  props: {
    daterange: { types: String, require: true },
  },
}
</script>